import React from 'react';
import { CustomDialog } from '../Components/CustomDialog';
import { dialogConfigs } from '../Utils/PMHelper';
import { TChannel } from '../Types/channel.types';

interface CreateChannelDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: any) => void;
    isLoading?: boolean;
    editData?: TChannel | null;
    mode?: 'create' | 'edit';
}

export const CreateChannelDialog = ({ 
    isOpen, 
    onClose, 
    onSave, 
    isLoading = false,
    editData = null,
    mode = 'create'
}: CreateChannelDialogProps) => {
    
    const getFields = () => {
        const baseFields = [...dialogConfigs.createChannel.fields];
                
        if (mode === 'edit' && editData) {
            return baseFields.map(field => {
                switch (field.name) {
                    case 'channelName':
                        return { ...field, defaultValue: editData.name };
                    default:
                        return field;
                }
            });
        }
        
        return baseFields;
    };

    return (
        <CustomDialog
            isOpen={isOpen}
            onClose={onClose}
            title={mode === 'edit' ? 'Edit Channel' : dialogConfigs.createChannel.title}
            fields={getFields()}
            onSave={onSave}
            saveButtonText={mode === 'edit' ? 'Update' : 'Create'}
            isLoading={isLoading}
        />
    );
};